import { frontendURL } from '../../../helper/URLHelper';
import LeadsIndex from './pages/LeadsIndex.vue';
import LeadDetailView from './pages/LeadDetailView.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/leads'),
    component: LeadsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'leads_dashboard_index',
        component: LeadsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/leads/:leadId'),
    component: LeadDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'leads_dashboard_show',
        component: LeadDetailView,
        meta: commonMeta,
      },
    ],
  },
];
